import {
  adjust,
  assocPath,
  compose,
  curry,
  path,
  pathEq,
} from 'ramda';

const targetsCheckBox = pathEq(['target', 'type'], 'checkbox');

const getEventChecked = path(['target', 'checked']);

const getEventValue = path(['target', 'value']);

const getErrorField = field => `${field}Error`;

export default curry((component, accessor, callback = () => { }) => (event) => {
  const value = targetsCheckBox(event) ? getEventChecked(event) : getEventValue(event);
  const errorAccessor = Array.isArray(accessor)
    ? adjust(-1, getErrorField, accessor)
    : getErrorField(accessor);
  const update = Array.isArray(accessor)
    ? compose(assocPath(errorAccessor, null), assocPath(accessor, value))
    : { [accessor]: value, [errorAccessor]: null };

  component.setState(update, callback);

  return value;
});
